import { ChevronRight } from '@mui/icons-material';
import { OverflowTooltip } from 'components/ui';
import {
  Footer,
  FooterClearHistory,
  FooterContext,
  FooterContextName,
  FooterTrailing,
  KeyCap,
  KeyHint,
} from './SuperSearch.styles';
import { SUPER_SEARCH_TEST_IDS } from './SuperSearch.testIds';
import type { SuperSearchContext, SuperSearchShortcut } from './SuperSearch.types';

interface SuperSearchFooterProps {
  canClearHistory?: boolean;
  context: SuperSearchContext;
  onClearHistory?: () => void;
  pressedShortcut?: SuperSearchShortcut;
  tabActionLabel?: 'complete' | 'set scope';
}

const SuperSearchFooter = ({
  canClearHistory,
  context,
  onClearHistory,
  pressedShortcut,
  tabActionLabel,
}: SuperSearchFooterProps) => (
  <Footer aria-label="Super Search keyboard shortcuts" role="note">
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'navigate' || undefined}>↑↓</KeyCap> navigate
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'go' || undefined}>↵</KeyCap> go
    </KeyHint>
    {tabActionLabel && (
      <KeyHint>
        <KeyCap data-pressed={pressedShortcut === 'setScope' || undefined}>tab</KeyCap> {tabActionLabel}
      </KeyHint>
    )}
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'popScope' || undefined}>⌫</KeyCap> pop scope
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'close' || undefined}>esc</KeyCap> close
    </KeyHint>
    {(canClearHistory || context.firm || context.company) && (
      <FooterTrailing>
        {canClearHistory && onClearHistory && (
          <FooterClearHistory
            aria-label="Clear Super Search history"
            data-testid={SUPER_SEARCH_TEST_IDS.clearHistory}
            onClick={onClearHistory}>
            Clear history
          </FooterClearHistory>
        )}
        {(context.firm || context.company) && (
          <FooterContext>
            {context.firm && (
              <OverflowTooltip placement="top" title={context.firm.name}>
                <FooterContextName tone="firm">{context.firm.name}</FooterContextName>
              </OverflowTooltip>
            )}
            {context.company && (
              <>
                <ChevronRight />
                <OverflowTooltip placement="top" title={context.company.name}>
                  <FooterContextName tone="company">{context.company.name}</FooterContextName>
                </OverflowTooltip>
              </>
            )}
          </FooterContext>
        )}
      </FooterTrailing>
    )}
  </Footer>
);

export default SuperSearchFooter;
